var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccount = function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0A10.5 10.5 0 0 0 0 10.5a10.33 10.33 0 0 0 5 8.9l.1.1a10.93 10.93 0 0 0 5.4 1.5 10.64 10.64 0 0 0 5.4-1.5h.1A10.54 10.54 0 0 0 10.5 0M6.7 19.2a2.08 2.08 0 0 1-1.1-1.7 4.9 4.9 0 1 1 9.8 0 1.88 1.88 0 0 1-1.1 1.7 10 10 0 0 1-3.8.8 9.2 9.2 0 0 1-3.8-.8M17.4 17c-.3.3-.8.6-1-.4a6 6 0 0 0-11.8.1c-.2 1-.6.7-1 .4a9.55 9.55 0 1 1 13.8-.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.3a3.6 3.6 0 1 0 3.6 3.6 3.59 3.59 0 0 0-3.6-3.6m0 6.2a2.6 2.6 0 1 1 2.6-2.6 2.65 2.65 0 0 1-2.6 2.6"
  })));
};
export default SvgAccount;